var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCrossRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8815 19.0002L37.7674 6.11397C38.0767 5.80463 38.0767 5.30318 37.7674 4.99384L33.0068 0.232106C32.8583 0.0835739 32.6563 0 32.4468 0C32.2368 0 32.0352 0.0835739 31.8867 0.232106L19.0001 13.1187L6.11344 0.232106C5.81638 -0.0649579 5.29038 -0.0649579 4.99332 0.232106L0.232373 4.99384C-0.0769694 5.30318 -0.0769694 5.80463 0.232373 6.11397L13.1186 19.0002L0.232373 31.8864C-0.0769694 32.1958 -0.0769694 32.6972 0.232373 33.0066L4.99332 37.7679C5.14185 37.9164 5.34345 38 5.55338 38C5.7633 38 5.96491 37.9164 6.11344 37.7679L19.0001 24.8813L31.8867 37.7679C32.0352 37.9164 32.2368 38 32.4468 38C32.6563 38 32.8583 37.9164 33.0068 37.7679L37.7678 33.0066C38.0771 32.6972 38.0771 32.1954 37.7678 31.8864L24.8815 19.0002Z",
    fill: "#D7181D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossRemove);
export default __webpack_public_path__ + "static/media/icon-cross-remove.a8e21c1885a47d683c31b02d7b1cf950.svg";
export { ForwardRef as ReactComponent };